import { shapes } from '@joint/plus';
import React, { ChangeEvent, ReactElement, useCallback, useEffect, useState } from 'react';

import Input from '../Input/Input';
import Select from '../Input/Select/Select';
import { useBaseInspector } from './useBaseInspector';

import ClearIcon from '@mui/icons-material/Clear';
import { Box, Dialog, DialogTitle, Switch } from '@mui/material';
import ReactQuill from 'react-quill';
import RequestIntegrationService from 'src/pages/integration-service-edit/components/request-integration-service';
import * as IntegrationService from "../../../../../../../../services/integrationservice.service";
import HelperCustomField from '../../HelperCustomField/HelperCustomField';

interface Props {
    cell: shapes.app.Service;
    chatbotFlowId: string;
}

const cellProps = {
    label: ['attrs', 'label', 'text'],
    description: ['attrs', 'description', 'text'],
    displayText: ['attrs', 'displayText', 'text'],
    icon: ['attrs', 'icon', 'xlinkHref'],
    portLabel: ['attrs', 'portLabel', 'text'],
    serviceId: ['attrs', 'serviceId', 'id'],
    isTextRich: ['attrs', 'isTextRich', 'isTextRich'],
};

const ServiceInspector = (props: Props): ReactElement => {

    const { cell, chatbotFlowId } = props;

    const [servicesOptions, setServicesOptions] = useState([]);

    const [label, setLabel] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [serviceId, setServiceId] = useState(null);
    const [isTextRich, setIsTextRich] = useState<boolean>(false);
    const [displayText, setDisplayText] = useState<string>(''); 

    const [isDisplayTextOnFocus, setIsDisplayTextOnFocus] = useState<boolean>(false);

    const [openModal, setOpenModal] = useState(false);

    const assignFormFields = useCallback((): void => {
        setLabel(cell.prop(cellProps.label));
        setDescription(cell.prop(cellProps.description));
        setServiceId(cell.prop(cellProps.serviceId));
        setIsTextRich(cell.prop(cellProps.isTextRich));
        setDisplayText(cell.prop(cellProps.displayText))
    }, [cell]);

    const changeCellProp = useBaseInspector({ cell, assignFormFields });

    const fetchServices = async () => {
        const services = await IntegrationService.getList();
        setServicesOptions(services ?? []);
    }

    useEffect(() => {
        fetchServices();
    }, [])

    return (
        <>
            <h1>Componente selecionado</h1>

            <label>Label
                <Input type="text"
                       placeholder="Enter label"
                       value={label}
                       disabled={true}
                />
            </label>

            <div style={{ marginBottom: '8px', marginTop: '8px'}}>
                <Switch
                    value={isTextRich}
                    checked={isTextRich}
                    onChange={(e:any) => changeCellProp(cellProps.isTextRich, e?.target?.checked)}     
                />
                <label>É um texto rico?</label>
            </div>

            {
                isTextRich
                ? (
                    <label>Descrição
                        <div style={{ resize: "vertical", overflow: "auto", height: "250px", marginBottom: "24px", border: "1px solid #ccc" }}>
                            <ReactQuill
                                name="description"
                                style={{ height: '100%' }}
                                fullWidth
                                variant="outlined"
                                id="descriprion"
                                value={description}
                                onFocus={(e) => setIsDisplayTextOnFocus(false)}
                                onChange={(value: any) => changeCellProp(cellProps.description, value)}
                            />
                        </div>
                    </label>
                )
                : (
                    <label>Descrição
                        <Input 
                            type="text"
                            placeholder="Enter description"
                            value={description}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => changeCellProp(cellProps.description, e.target.value)}
                            onSetIsDisplayTextOnFocus={setIsDisplayTextOnFocus}
                        />
                    </label>
                )
            }

            <label>Texto de exibição
                <div style={{ resize: "vertical", overflow: "auto", height: "250px", marginBottom: "24px", border: "1px solid #ccc" }}>
                    <ReactQuill
                        name="description"
                        style={{ height: '100%' }}
                        fullWidth
                        variant="outlined"
                        id="descriprion"
                        onFocus={(e) => setIsDisplayTextOnFocus(true)}
                        value={displayText}
                        onChange={(value: any) => changeCellProp(cellProps.displayText, value)}
                    />
                </div>
            </label>

            <HelperCustomField
                isRichText={isDisplayTextOnFocus ? true : isTextRich}
                description={isDisplayTextOnFocus ? displayText : description}
                param1={isDisplayTextOnFocus ? cellProps.displayText : cellProps.description}
                onChangeDescription={changeCellProp}
                chatbotFlowId={chatbotFlowId}
            />

            <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                <label>Serviço
                    <Select
                        value={serviceId}
                        onChange={(e) => changeCellProp(cellProps.serviceId, e.target.value)}
                        options={servicesOptions}
                    />
                </label>

                {serviceId && (
                    <button className='button-save' onClick={() => setOpenModal(true)} style={{marginBottom: '16px'}}>
                        Testar serviço
                    </button>
                )}
            </div>

            <>
                <Dialog 
                    open={openModal} 
                    onClose={() => setOpenModal(false)} 
                    aria-labelledby="form-dialog-title"  
                    fullWidth
                    maxWidth="lg" 
                    PaperProps={{
                        style: { width: "100%", maxWidth: "900px", minHeight: '400px' } 
                    }}
                >
                    <DialogTitle id="form-dialog-title">
                        Testar serviço
                        <ClearIcon 
                            onClick={() => setOpenModal(false)} 
                            style={{ float: 'right', cursor : 'pointer'}}
                        /> 
                    </DialogTitle>
                    <Box>
                        <div style={{width: '100%', padding: '24px'}}>
                            <RequestIntegrationService
                                token={null}
                                integrationServiceId={serviceId}
                                isOpenFromJoint={true}
                            />
                        </div>
                    </Box>     
                </Dialog>
            </>

        </>
    );
};

export default ServiceInspector;
